module.exports = __webpack_public_path__ + "img/sld_scb_16_t1_green.e930e8f2.svg";